/* unplugin-vue-components disabled */import { render, staticRenderFns } from "./Detail.vue?vue&type=template&id=2aa1d9aa&scoped=true&"
import script from "./Detail.vue?vue&type=script&setup=true&lang=js&"
export * from "./Detail.vue?vue&type=script&setup=true&lang=js&"
import style0 from "./Detail.vue?vue&type=style&index=0&id=2aa1d9aa&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2aa1d9aa",
  null
  
)

export default component.exports